import { takeEvery, put, select, delay } from 'redux-saga/effects'
import { change } from 'redux-form/immutable'

import { TIME_PREFERENCES_FORM } from 'app/constants/profile'
// @ts-ignore
import { types } from 'app/constants/notificationType'
import { triggerAddMobileNumber } from 'store/entities/onBoarding/actions'
import { isWaiting } from 'store/entities/offline/selectors'
import { isMobile } from 'react-device-detect'
import { scrollToUserBoard } from 'helpers/onboarding'

const WAITING_SECONDS = 20 // in seconds
const DELAY = 100 // in milliseconds
const LIMIT_TIME_FOR_WAIT = (1000 * WAITING_SECONDS) / DELAY

export default function* addMobileNumberSaga() {
  yield takeEvery(triggerAddMobileNumber.toString(), handleAddMobileNumber)
}

export function* handleAddMobileNumber() {
  yield scrollToUserBoard()
  if (isMobile) {
    const notificationType = document.getElementById('notificationtype') as any
    notificationType.scrollIntoView()
    window.scrollBy(0, -70)
  }
  let times = 0
  while (yield select(isWaiting)) {
    times++
    if (times > LIMIT_TIME_FOR_WAIT) {
      return
    }
    yield delay(DELAY)
  }
  return yield put(change(TIME_PREFERENCES_FORM, 'notificationType', types.BOTH))
}
